var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormGroup",
        [
          _c("RadioGroup", {
            attrs: { options: _vm.yesNoOptions },
            on: { change: _vm.emitChangeEvent },
            model: {
              value: _vm.yesNo,
              callback: function($$v) {
                _vm.yesNo = $$v
              },
              expression: "yesNo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.extraDataEligible
        ? _c("div", { staticClass: "sections mt-4" }, [
            _c(
              "section",
              [
                _c("h3", [_vm._v("In welchem Umfang würdest du reisen?")]),
                _vm._v(" "),
                _c("SelectInline", {
                  attrs: {
                    "characteristic-items": _vm.meta.travelWillingness,
                    "single-choice": "",
                    "label-type": "application"
                  },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.scope,
                    callback: function($$v) {
                      _vm.scope = $$v
                    },
                    expression: "scope"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("h3", [
                  _vm._v("Würdest du auch beruflich extern übernachten?")
                ]),
                _vm._v(" "),
                _c("RadioGroup", {
                  attrs: { options: _vm.yesNoOptions },
                  on: { change: _vm.emitChangeEvent },
                  model: {
                    value: _vm.externalSleepoverYesNo,
                    callback: function($$v) {
                      _vm.externalSleepoverYesNo = $$v
                    },
                    expression: "externalSleepoverYesNo"
                  }
                }),
                _vm._v(" "),
                _vm.externalSleepoverYesNo
                  ? _c(
                      "div",
                      { staticClass: "mt-4 pl-4" },
                      [
                        _c("h3", [
                          _vm._v("Wie viele Übernachtungen wären in Ordnung?")
                        ]),
                        _vm._v(" "),
                        _c("SelectInline", {
                          attrs: {
                            "characteristic-items": _vm.meta.externalSleepover,
                            "single-choice": "",
                            "label-type": "application"
                          },
                          on: { input: _vm.emitChangeEvent },
                          model: {
                            value: _vm.externalSleepoverScope,
                            callback: function($$v) {
                              _vm.externalSleepoverScope = $$v
                            },
                            expression: "externalSleepoverScope"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }